import { useNavigate } from "react-router";
import { useIsTripCreated } from "src/domain/TripPlanner/hooks/useTripURL";
import { navigateToNewStateHash } from "../location/navigateToNewStateHash";
import { useTypedLocation } from "./useTypedLocation";
import useUser from "./useUser";

export function useNavigateToTrips() {
  const location = useTypedLocation();
  const navigate = useNavigate();
  const isTripCreated = useIsTripCreated();
  const isUserLoggedIn = !!useUser().user?.id;
  let tripsHash = "#trips";

  if (!isTripCreated) {
    tripsHash = `#trips/${isUserLoggedIn ? "saved" : "create"}`;
  }

  const navigateToTrips = function () {
    navigateToNewStateHash(
      navigate,
      { highlightedTab: "trips" },
      tripsHash,
      location,
      true,
    );
  };
  return { tripsHash, navigateToTrips };
}
